import { isValidEmail } from 'volto-form-block/helpers/validators';
export const isValidREREmail = (email) => {
  const isValid =
    isValidEmail(email) && email.indexOf('@regione.emilia-romagna.it') > 0;
  return isValid;
};
